import type { QuerySort } from "@glide/computation-model-types";

// Increased limit to handle large datasets with many unique timestamps
// TODO: Optimize by grouping at the database level by truncated date intervals
export const dataPlotDefaultGroupLimit = 50_000;

interface XAxisGroupOptions {
    readonly sort: readonly QuerySort[];
    readonly limit: number;
    // When keeping only the last N X-axis values we query the groups in
    // descending order, so the chart data must be reversed for display.
    readonly reverseForDisplay: boolean;
}

// If `xAxisLimit` is set, the chart shows only the `xAxisLimit` highest
// X-axis values, i.e. the most recent ones for time-like axes.  The display
// order stays ascending unless the builder explicitly sorts the X-axis
// column descending.
export function getGroupOptionsForXAxisLimit(
    xAxisColumnName: string,
    maybeSort: QuerySort | undefined,
    xAxisLimit: number | undefined
): XAxisGroupOptions {
    if (xAxisLimit === undefined) {
        return {
            sort: [maybeSort ?? { columnName: xAxisColumnName, order: "asc" }],
            limit: dataPlotDefaultGroupLimit,
            reverseForDisplay: false,
        };
    }

    const displaysDescending = maybeSort?.columnName === xAxisColumnName && maybeSort.order === "desc";
    return {
        sort: [{ columnName: xAxisColumnName, order: "desc" }],
        limit: xAxisLimit,
        reverseForDisplay: !displaysDescending,
    };
}
